import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutenticacionService } from '../servicios/autenticacion.service';
import { DialogoActualizarPasswordComponent } from '../dialogo-actualizar-password/dialogo-actualizar-password.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
//import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
@Component({
    selector: 'app-datos-usuario',
    templateUrl: './datos-usuario.component.html',
    styleUrls: ['./datos-usuario.component.css'],
    standalone: true,
    imports: [MatListModule, FormsModule, MatIconModule, NbCardModule, NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, MultiSelectModule],
})
export class DatosUsuarioComponent implements OnInit {
  userName: string;
  nombre: string;
  apellido: string
  correoElectronico: string;
  perfil: string;

  constructor(private AutenticacionService: AutenticacionService, public dialog: MatDialog,
    private router: Router) { }

  ngOnInit(): void {
    this.userName = localStorage.getItem('username');
    this.traerDatosUsuario();
  }

  traerDatosUsuario(){
    this.AutenticacionService.getUsername(this.userName).subscribe(datosUsuario => {
      this.userName = datosUsuario['username'];
      this.nombre = datosUsuario['nombre'];
      this.apellido = datosUsuario['apellido'];
      this.correoElectronico = datosUsuario['correoElectronico'];
      this.perfil = datosUsuario['perfil'].descripcion
    })
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogoActualizarPasswordComponent, {
      width: '600px', height: '285px'
    });
  }

  cancelar(){
    this.router.navigate(['/']);
  }

}
